// src/validationSchema.ts
import { PaymentFI } from "@/components/Payment/PaymentForm/enums/PaymentFI.ts";
import * as yup from "yup";

const cardNumberRegex = /^[0-9]{4} [0-9]{4} [0-9]{4} [0-9]{4}$/;
const expiryDateRegex = /^(0[1-9]|1[0-2])\/?([0-9]{2})$/;
// preserved, uncomment if needed
// const cvvRegex = /^[0-9]{3}$/;

export const paymentFormValidationSchema = yup.object().shape({
  [PaymentFI.SameAsBooker]: yup.boolean(),
  [PaymentFI.HolderFirstName]: yup.string().when(PaymentFI.SameAsBooker, {
    is: false,
    then: (schema) => schema.required(" "),
    otherwise: (schema) => schema.optional(),
  }),
  [PaymentFI.HolderLastName]: yup.string().when(PaymentFI.SameAsBooker, {
    is: false,
    then: (schema) => schema.required(" "),
    otherwise: (schema) => schema.optional(),
  }),
  [PaymentFI.CardNumber]: yup.string().required(" ").matches(cardNumberRegex, "Card number is invalid"),
  [PaymentFI.ExpiryDate]: yup
    .string()
    .required(" ")
    .matches(expiryDateRegex, "Expiry date is invalid")
    .test("expiryDate", "Expiry date is invalid", (value) => {
      if (!value) return false;
      const [month, year] = value.split("/");
      const expiryMonth = parseInt(month, 10);
      const expiryYear = parseInt(`20${year}`, 10);
      const now = new Date();
      const currentMonth = now.getMonth() + 1;
      const currentYear = now.getFullYear();
      return expiryYear > currentYear || (expiryYear === currentYear && expiryMonth >= currentMonth);
    }),
  // preserved, uncomment if needed
  // cvv: yup.string().required("CVV is required").matches(cvvRegex, "CVV is invalid"),
});
